import React from 'react';
import PropTypes from 'prop-types';
import {browserHistory} from 'react-router';
import axios from 'axios';
import classNames from 'classnames';
import AppBar from 'material-ui/AppBar';
import Typography from 'material-ui/Typography';
import Tabs, {Tab} from 'material-ui/Tabs';
import {withStyles} from 'material-ui/styles';
import * as host from "../host/host";

const drawerWidth = 300;
const styles = theme => ({
    button: {
        margin: theme.spacing.unit
    },
    fullWidthButtonHeaderBlock: {
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    fullWidthButtonHeader: {
        marginTop: '12px',
        width: '100%',
        height: '54px',
        /*backgroundColor: 'transparent',
        color: '#ffffff',*/
        fontSize: '20px',
        fontWeight: 'normal',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        transition: '.5s all'
    },
    fullWidthButtonHeaderText: {
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    fullWidthButton: {
        marginTop: theme.spacing.unit,
        width: '100%',
        height: '56px',
        /*backgroundColor: 'transparent',
        color: '#ffffff',*/
        fontSize: '20px',
        fontWeight: 'normal',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        transition: '.5s all',
        borderRadius: '2px 2px 0 0'
    },
    navigationBlock: {
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    root: {
        width: '100%'
    },
    flex: {
        flex: 0,
    },
    float: {
        float: 'right'
    },
    contentLeftMarginMd: {
        //marginBottom: 17,
        [theme.breakpoints.up('md')]: {
            marginLeft: '300px',
            width: 'calc(100% - 300px)'
        }
    },
    appBarLeftMarginMd: {
        [theme.breakpoints.up('md')]: {
            /*marginLeft: '220px',*/
            width: '100%'
            //width: 'calc(100% - 300px)'
        }
    },
    leftMarginMd: {
        [theme.breakpoints.up('md')]: {
            marginLeft: '300px'
            /*width: '100%'*/
        }
    },
    drawerPaper: {
        width: 300,
        overflowY: 'scroll',
        [theme.breakpoints.up('md')]: {
            marginTop: '72px',
            width: drawerWidth,
            position: 'absolute'
        }
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    drawerHeader: theme.mixins.toolbar,
    content: {
        backgroundColor: theme.palette.background.default,
        width: '100%',
        padding: theme.spacing.unit * 3,
        height: 'calc(100% - 56px)',
        marginTop: 56,
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100% - 72px)',
            marginTop: 72
        }
    },
    bigAvatar: {
        width: 60,
        height: 60,
    },
    appBarColors: {
        //backgroundColor: '#009688',
        backgroundColor: '#273140',
        height: '72px',
        padding: '5px 0'
        //marginBottom: '30px'
    },
    drawerColors: {
        /*backgroundColor: '#02373a',
        color: '#ffffff'*/
    },
    bodyColors: {
        /*backgroundColor: '#05655d',
        color: '#ffffff'*/
    },
    drawerHeight: {
        /*height: 'calc(200vh - 64px)',*/
        /*[theme.breakpoints.up('md')]: {
            maxHeight: 'calc(200vh - 64px)',
            //display: 'none'
        },*/
        /*maxHeight: '100%',*/
        /*minHeight: '100vh'*/
    },
    tab: {
        fontSize: '1.4rem',
        //fontWeight: '900',
        color: 'black'
    },
    routerBlock: {
        zIndex: 10,
        opacity: 0,
        maxHeight: 0,
        transition: 'all .3s',
        transform: 'scaleY(0)',
        transformOrigin: 'top',
        [theme.breakpoints.up('md')]: {
            marginTop: 20
        }
    },
    rightSideScroll: {
        // height: 'calc(100vh + 34px)',
        // overflowY: 'scroll'
    },
    svgDeterminate: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        width: '200px',
        height: '200px'
    }
});

function TabContainer(props) {
    return (
        <Typography component="div"
                    style={props.journalPadding || props.analyticsPadding ? {padding: 0} : {padding: 24}}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

class App extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleSettingsClick = this.handleSettingsClick.bind(this);
        this.handleRequestClose = this.handleRequestClose.bind(this);
        this.handleSettingsClose = this.handleSettingsClose.bind(this);
        this.logInHandler = this.logInHandler.bind(this);
        this.logOutHandler = this.logOutHandler.bind(this);
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.navigateToAccount = this.navigateToAccount.bind(this);
        this.updateData = this.updateData.bind(this);
        this.handleTabsChange = this.handleTabsChange.bind(this);
        this.getCompanyData = this.getCompanyData.bind(this);
        this.chooseCompany = this.chooseCompany.bind(this);
        this.resetCompanySelect = this.resetCompanySelect.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.updateJournalData = this.updateJournalData.bind(this);
        this.updateAccountsData = this.updateAccountsData.bind(this);
        this.updateCounterpartyData = this.updateCounterpartyData.bind(this);
        this.updateProjectData = this.updateProjectData.bind(this);
        this.updateTagsData = this.updateTagsData.bind(this);
        this.updateIncomeCategoryData = this.updateIncomeCategoryData.bind(this);
        this.updateConsumptionCategoryData = this.updateConsumptionCategoryData.bind(this);
        this.updateTagsData = this.updateTagsData.bind(this);
        this.updateInputsData = this.updateInputsData.bind(this);
        this.getFiltersData = this.getFiltersData.bind(this);
        this.updateFiltersData = this.updateFiltersData.bind(this);
        this.updateReportsData = this.updateReportsData.bind(this);
        this.updateDemoCompanyFlag = this.updateDemoCompanyFlag.bind(this);
        this.calculateCompanyBalance = this.calculateCompanyBalance.bind(this);
        this.calculateInnerSum = this.calculateInnerSum.bind(this);
        this.calculateOuterSum = this.calculateOuterSum.bind(this);
        this.handleLoginValueChange = this.handleLoginValueChange.bind(this);

        this.state = {
            inputs: {},

            incomeInputs: [],
            consumptionInputs: [],
            transferInputs: [],

            balance: [],
            journalData: [],
            journalFiltersData: {},
            accounts: {data: []},
            accounts_types: [],

            inner_accounts_balance_sum: 0,
            outer_accounts_balance_sum: 0,

            company_balance: 0,

            currency: {},

            counterparty: [],
            project: [],
            tags: [],
            incomeCategories: [],
            consumptionCategories: [],
            reports: [],

            tabValue: 0,

            mobileOpen: false,

            anchorEl: undefined,
            open: false,
            settingsOpen: false,
            isLoggingIn: false,
            companySelected: false,
            email: null,
            role_id: 0,
            company_name: null,

            _id: null,

            is_owner: false,
            has_demo_company: false,

            circularProgress: false,

            login_value: '',
        };
    }

    handleLoginValueChange(event) {
        const _this = this;
        _this.setState({
            login_value: event.target.value
        });
    }

    handleTabChange = (event, value) => {
        const _this = this;
        _this.setState({tabValue: value});
        if (value === 0) {
            browserHistory.push('/leads');
        }
        else if (value === 1) {
            browserHistory.push('/users');
        }
        else if (value === 2) {
            browserHistory.push('/companies');
        }
        else if (value === 3) {
            browserHistory.push('/analytics');
        }
    };

    calculateCompanyBalance(array) {
        const _this = this;
        let sum = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i]._ids.includes(_this.state.role_id)) {
                sum += array[i].balance;
            }
        }
        return sum;
    }

    calculateInnerSum(array) {
        const _this = this;
        let sum = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i]._ids.includes(_this.state.role_id) && array[i].account_type.value === 'Внутренний') {
                sum += array[i].balance;
            }
        }
        return sum;
    }

    calculateOuterSum(array) {
        const _this = this;
        let sum = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i]._ids.includes(_this.state.role_id) && array[i].account_type.value === 'Внешний') {
                sum += array[i].balance;
            }
        }
        return sum;
    }

    getCompanyData(_id) {
        const _this = this;
        axios({
            method: 'post',
            url: host.url + '/companies/choose_company',
            data: {
                company_id: localStorage.getItem("finMapSelectedCompany"),
                user_id: _id
            }
        }).then(function (response) {
            console.log('choose_company', response);
            let data = response.data;

            //Получение role_id и статуса is_owner
            for (let i = 0; i < data.data.users.length; i++) {
                if (_this.state._id === data.data.users[i].user_id) {
                    console.log(true);
                    _this.setState({
                        role_id: data.data.users[i].role_id,
                        is_owner: data.data.users[i].is_owner
                    });
                } else {
                    console.log(false);
                }
            }

            //Получение инпутов и названия компании
            _this.setState({
                journalData: response.data.data.journal,
                inputs: response.data.data.inputs,
                incomeInputs: response.data.data.inputs.income,
                consumptionInputs: response.data.data.inputs.consumption,
                transferInputs: response.data.data.inputs.transfer,
                company_name: response.data.data.name,
                currency: response.data.data.currency,
                accounts: response.data.data.inputs.accounts,
                accounts_types: response.data.data.inputs.accounts.accounts_types,
                counterparty: response.data.data.inputs.counterparty,
                project: response.data.data.inputs.projects,
                tags: response.data.data.inputs.tags,
                reports: response.data.data.reports,
                incomeCategories: response.data.data.inputs.income[0],
                consumptionCategories: response.data.data.inputs.consumption[0],
                company_balance: _this.calculateCompanyBalance(response.data.data.inputs.accounts.data),
                inner_accounts_balance_sum: _this.calculateInnerSum(response.data.data.inputs.accounts.data),
                outer_accounts_balance_sum: _this.calculateOuterSum(response.data.data.inputs.accounts.data)
            }, function () {
                _this.setState({
                    circularProgress: false
                });
            });

            //Флаг выбора компании
            _this.setState({
                companySelected: true
            });

        }).then(function () {
            _this.getFiltersData(_id);
        }).then(function () {
            browserHistory.push('/');
        }).catch(function (error) {
            console.log(error);
            if (error) {
                _this.logOutHandler();
            }
        });
    }

    getFiltersData(_id) {
        const _this = this;
        axios({
            method: 'post',
            url: host.url + '/journal/get_filters_data',
            data: {
                company_id: localStorage.getItem("finMapSelectedCompany"),
                user_id: _id,
                role_id: _this.state.role_id
            }
        }).then(function (response) {
            console.log('getFiltersData', response);
            _this.setState({
                journalFiltersData: response.data.data
            });
        });
    }

    updateFiltersData() {
        const _this = this;
        axios({
            method: 'post',
            url: host.url + '/journal/get_filters_data',
            data: {
                company_id: localStorage.getItem("finMapSelectedCompany"),
                user_id: _this.state._id,
                role_id: _this.state.role_id
            }
        }).then(function (response) {
            console.log('getFiltersData', response);
            _this.setState({
                journalFiltersData: response.data.data
            });
        });
    }

    chooseCompany(_id) {
        const _this = this;
        console.log('Company choose');
        console.log(_id);
        localStorage.setItem('finMapSelectedCompany', _id);

        axios({
            method: 'post',
            url: host.url + '/companies/choose_company',
            data: {
                company_id: _id,
                user_id: _this.state._id
            }
        }).then(function (response) {
            console.log('choose_company', response);
            _this.getCompanyData(_this.state._id);
        });
    }

    resetCompanySelect() {
        const _this = this;
        _this.setState({
            companySelected: false,
            settingsOpen: false
        });
        localStorage.removeItem("finMapSelectedCompany");
    }

    handleDrawerToggle() {
        this.setState({mobileOpen: !this.state.mobileOpen});
    }

    handleClick(event) {
        this.setState({open: true, anchorEl: event.currentTarget});
    }

    handleSettingsClick(event) {
        this.setState({settingsOpen: true, anchorEl: event.currentTarget});
    }

    handleRequestClose() {
        this.setState({open: false});
    }

    handleSettingsClose() {
        this.setState({settingsOpen: false});
    }

    updateData() {
        const _this = this;
        _this.setState({
            isLoggingIn: true,
        }, () => {
            browserHistory.push('/leads');
        });
    }

    logInHandler(response) {
        const _this = this;
      //  if (!_this.state.isLoggingIn) {
            _this.updateData(response);
      //  }
    }

    logOutHandler() {
        const _this = this;
    //    if (_this.state.isLoggingIn) {
            _this.setState({
                open: false,
                settingsOpen: false,
                isLoggingIn: false
            });
         //   _this.resetCompanySelect();
            if (localStorage.getItem("finMapAdminToken")) {
                localStorage.removeItem('finMapAdminToken');
            }
            if(_this.props.location.pathname !== '/login') {
                browserHistory.push('/login');
            }
   //     }
    }

    navigateToAccount(name) {
        /*console.log(name);*/
        browserHistory.push(`/balance/${name}`);
    }

    handleTabsChange = (event, value) => {
        this.setState({tabValue: value});
    };

    updateJournalData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/journal/get_journal_data',
            method: 'post',
            data: data
        }).then(function (response) {
            _this.setState({
                journalData: response.data.data[0].journal
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateAccountsData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/companies/get_company_accounts',
            method: 'post',
            data: data
        }).then(function (response) {
            _this.setState({
                accounts: response.data.data.inputs.accounts,
                company_balance: _this.calculateCompanyBalance(response.data.data.inputs.accounts.data),
                inner_accounts_balance_sum: _this.calculateInnerSum(response.data.data.inputs.accounts.data),
                outer_accounts_balance_sum: _this.calculateOuterSum(response.data.data.inputs.accounts.data),
            })
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateCounterpartyData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/companies/get_company_counterparty',
            method: 'post',
            data: data
        }).then(function (response) {
            //console.log(response);
            _this.setState({
                counterparty: response.data.data.inputs.counterparty
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateProjectData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/companies/get_company_project',
            method: 'post',
            data: data
        }).then(function (response) {
            //console.log(response);
            _this.setState({
                project: response.data.data.inputs.projects
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateTagsData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/companies/get_company_tags',
            method: 'post',
            data: data
        }).then(function (response) {
            //console.log(response);
            _this.setState({
                tags: response.data.data.inputs.tags
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateIncomeCategoryData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/companies/get_company_category_income',
            method: 'post',
            data: data
        }).then(function (response) {
            //console.log(response);
            _this.setState({
                incomeCategories: response.data.data.inputs.income[0]
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateConsumptionCategoryData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/companies/get_company_category_consumption',
            method: 'post',
            data: data
        }).then(function (response) {
            //console.log(response);
            _this.setState({
                consumptionCategories: response.data.data.inputs.consumption[0]
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateInputsData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/companies/get_company_inputs',
            method: 'post',
            data: data
        }).then(function (response) {
            //console.log(response);
            _this.setState({
                inputs: response.data.data.inputs
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateReportsData() {
        const _this = this;
        let data = {
            user_id: _this.state._id,
            company_id: localStorage.getItem('finMapSelectedCompany')
        };
        axios({
            url: host.url + '/reports/get_reports',
            method: 'post',
            data: data
        }).then(function (response) {
            _this.setState({
                reports: response.data.data[0].reports
            });
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateDemoCompanyFlag(data) {
        const _this = this;
        _this.setState({
            has_demo_company: data
        });
    }

    componentDidMount() {
        const _this = this;
        console.log('componentDidMount App', _this.props);
        if (localStorage.getItem("finMapAdminToken")) {
            axios({
                method: 'post',
                url: host.url + '/admin/auth',
                data: {
                    token: localStorage.getItem("finMapAdminToken")
                }
            }).then(function (response) {
                console.log('auth', response);
                if (response.data.token && response.data.status) {
                    localStorage.setItem('finMapAdminToken', response.data.token);
                    _this.setState({
                        isLoggingIn: true,
                    });
                }
            }).catch(function () {
                browserHistory.push('/login');
            });
        } else {
            browserHistory.push('/login');
        }
        _this.updateTabValue(_this.props);
    }

    componentWillReceiveProps(nextProps){
        const _this = this;
        console.log('componentWillReceiveProps App', nextProps);
        if(nextProps.location.pathname !== _this.props.location.pathname){
            console.log('update tab value');
            _this.updateTabValue(nextProps);
        }
    }

    updateTabValue(props) {
        const _this = this;
        let tabValue = 0;
        if(props.location.pathname === '/leads') {
            tabValue = 0;
        }
        else if(props.location.pathname.indexOf('/users') === 0) {
            tabValue = 1;
        }
        else if(props.location.pathname.indexOf('/companies') === 0) {
            tabValue = 2;
        }
        else if(props.location.pathname === '/analytics') {
            tabValue = 3;
        }
        _this.setState({
            tabValue: tabValue
        });
    }

    render() {
        const _this = this;
        const {classes} = _this.props;

        const childrenWithProps = React.Children.map(_this.props.children,
            (child) => React.cloneElement(child, {
                inputs: _this.state.inputs,
                incomeInputs: _this.state.incomeInputs,
                consumptionInputs: _this.state.consumptionInputs,
                transferInputs: _this.state.transferInputs,
                logInHandler: _this.logInHandler,
                logOutHandler: _this.logOutHandler,
                requestData: _this.requestData,
                company_name: _this.state.company_name,
                currency: _this.state.currency,
                email: _this.state.email,
                _id: _this.state._id,
                role_id: _this.state.role_id,
                balance: _this.state.balance,
                journalData: _this.state.journalData,
                updateData: _this.updateData,
                chooseCompany: _this.chooseCompany,
                resetCompanySelect: _this.resetCompanySelect,
                updateJournalData: _this.updateJournalData,
                updateAccountsData: _this.updateAccountsData,
                updateCounterpartyData: _this.updateCounterpartyData,
                updateProjectData: _this.updateProjectData,
                updateTagsData: _this.updateTagsData,
                counterparty: _this.state.counterparty,
                project: _this.state.project,
                accounts: _this.state.accounts,
                tags: _this.state.tags,
                incomeCategories: _this.state.incomeCategories,
                consumptionCategories: _this.state.consumptionCategories,
                has_demo_company: _this.state.has_demo_company,
                updateDemoCompanyFlag: _this.updateDemoCompanyFlag,
                handleLoginValueChange: _this.handleLoginValueChange,
                login_value: _this.state.login_value,
                is_owner: _this.state.is_owner,
                updateFiltersData: _this.updateFiltersData,

                leads: _this.state.leads,
                users: _this.state.users,
                updateTabValue: _this.updateTabValue,
                user_link: _this.props.params && _this.props.params.user_link ? _this.props.params.user_link : '',
                company_link: _this.props.params && _this.props.params.company_link ? _this.props.params.company_link : '',
                companies: _this.state.companies
            })
        );

        return (
            <div>
                {!_this.state.isLoggingIn ? null :
                    <div className={classes.root}>
                        <div id={'head'} className={classes.rightSideScroll}>
                            <div className={classNames(classes.tabs)}>
                                <AppBar position="static" color="default">
                                    <Tabs
                                        value={_this.state.tabValue}
                                        onChange={_this.handleTabChange}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        scrollable
                                        scrollButtons="auto">
                                        <Tab classes={{label: classes.tab}} label="Лиды"/>
                                        <Tab classes={{label: classes.tab}} label="Юзеры"/>
                                        <Tab classes={{label: classes.tab}} label="Компании"/>
                                        <Tab classes={{label: classes.tab}} label="Аналитика"/>
                                    </Tabs>
                                </AppBar>
                            </div>
                        </div>
                    </div>
                }
                <div
                    // className={!_this.state.companySelected || !_this.state.isLoggingIn ? '' : classNames(classes.contentLeftMarginMd, classes.bodyColors, classes.routerBlock)}
                >
                    {childrenWithProps}
                </div>
            </div>
        );
    }
}

App.propTypes = {
    children: PropTypes.element
};

export default withStyles(styles, {withTheme: true})(App);


// WEBPACK FOOTER //
// ./src/components/App.js